import { Component, inject } from '@angular/core';
import {
  ClientsService,
  SelectedClient,
} from 'src/app/services/clients/clients.service';
import { HeaderComponent } from '../header/header.component';
import { MatButton } from '@angular/material/button';
import { PayeeIconComponent } from '../../../shared/payee-icon/payee-icon.component';
import { BankAccountEditComponent } from './bank-account-edit/bank-account-edit.component';
import { UserOptionsComponent } from './client-options/client-options.component';
import { ApiIntegrationsComponent } from './api-integrations/api-integrations.component';
import { NotificationSettingsComponent } from './notification-settings/notification-settings.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-client-profile',
  templateUrl: './client-profile.component.html',
  styleUrls: ['./client-profile.component.scss'],
  imports: [
    HeaderComponent,
    MatButton,
    PayeeIconComponent,
    BankAccountEditComponent,
    UserOptionsComponent,
    ApiIntegrationsComponent,
    NotificationSettingsComponent,
    TranslateModule,
  ],
})
export class ClientProfileComponent {
  private clientsService = inject(ClientsService);

  // tab = 'bank-account-edit';
  tab = 'notification-settings';
  get client(): SelectedClient | null {
    return this.clientsService.selectedClientSubject.value;
  }

  async copyIdToClipboard(event: Event): Promise<void> {
    event.stopPropagation();

    try {
      await navigator.clipboard.writeText(
        this.client?.client_reference_id ?? '',
      );
    } catch (error) {
      console.error('Failed to copy to clipboard', error);
    }
  }
}
